import { rem } from "polished";

import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";
import { baseButtonStyle } from "@/components/editor/themes/crosby/constants";
import {
  ColorLabels,
  useInvertedColor,
} from "@/components/editor/utils/use-color";

export const Wrapper = withViewportStyle("div")<{ inverted?: boolean }>`
  display: grid;
  grid-auto-rows: max-content;
  grid-gap: ${rem(16)};
  padding: ${rem(40)};
  border-radius: ${rem(24)};
  border: ${rem(2)} solid
    ${({ theme, inverted }) =>
      inverted ? "transparent" : theme.colors[ColorLabels.PRIMARY_FONT]};
  background-color: ${({ theme, inverted }) =>
    inverted
      ? useInvertedColor(theme.colors[ColorLabels.BACKGROUND]) === "#000000"
        ? "#758648"
        : theme.colors[ColorLabels.PRIMARY_FONT]
      : useInvertedColor(theme.colors[ColorLabels.BACKGROUND]) === "#000000"
      ? "#fff"
      : theme.colors[ColorLabels.BACKGROUND]};

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: ${({ theme, inverted }) =>
      inverted
        ? useInvertedColor(theme.colors[ColorLabels.PRIMARY_FONT])
        : theme.colors[ColorLabels.PRIMARY_FONT]}!important;
  }

  li,
  p {
    color: ${({ theme, inverted }) =>
      inverted
        ? useInvertedColor(theme.colors[ColorLabels.SECONDARY_FONT])
        : theme.colors[ColorLabels.SECONDARY_FONT]}!important;
  }

  .button-primitive {
    ${baseButtonStyle}
    margin: 0 auto;
  }

  .image-primitive {
    border-radius: ${rem(20)};
    width: ${rem(496)};
  }

  ${(props) => props.$viewport.tablet`
    .image-primitive {
      width: ${rem(366)};
    }
  `};

  ${(props) =>
    props.$viewport.mobile`
      padding: ${rem(40)} ${rem(24)} ${rem(24)};

      .button-primitive {
        width: 100%;
      }
  `};
`;
